import React from "react";
import { Box, Typography, useTheme, alpha } from "@mui/material";
import PropTypes from "prop-types";

interface Props {
  deliveredStatus: boolean;
  isBookAvailable: boolean;
}

export const MemoryBookStatusChip: React.FC<Props> = ({
  deliveredStatus,
  isBookAvailable,
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const getStatusConfig = () => {
    if (!isBookAvailable) {
      return {
        label: "Not Available",
        dotColor: "#94A3B8",
        color: isDark ? "#CBD5E1" : "#475569",
        bg: isDark ? alpha("#64748B", 0.18) : alpha("#64748B", 0.08),
        borderColor: isDark ? alpha("#64748B", 0.3) : alpha("#64748B", 0.18),
      };
    }
    if (deliveredStatus) {
      return {
        label: "Delivered",
        dotColor: "#10B981",
        color: isDark ? "#6EE7B7" : "#047857",
        bg: isDark ? alpha("#10B981", 0.18) : alpha("#10B981", 0.1),
        borderColor: isDark ? alpha("#10B981", 0.35) : alpha("#10B981", 0.25),
      };
    }
    return {
      label: "Book Uploaded",
      dotColor: "#F59E0B",
      color: isDark ? "#FCD34D" : "#B45309",
      bg: isDark ? alpha("#F59E0B", 0.18) : alpha("#F59E0B", 0.1),
      borderColor: isDark ? alpha("#F59E0B", 0.35) : alpha("#F59E0B", 0.25),
    };
  };

  const { label, dotColor, color, bg, borderColor } = getStatusConfig();

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.8,
        px: 1.25,
        py: 0.35,
        borderRadius: "20px",
        backgroundColor: bg,
        border: "1px solid",
        borderColor: borderColor,
        userSelect: "none",
        transition: "all 0.2s ease",
      }}
    >
      <Box
        sx={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          backgroundColor: dotColor,
          boxShadow: `0 0 0 2px ${alpha(dotColor, 0.2)}`,
          flexShrink: 0,
        }}
      />
      <Typography
        component="span"
        sx={{
          fontSize: "0.74rem",
          fontWeight: 600,
          color: color,
          lineHeight: 1.2,
          letterSpacing: "0.01em",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

MemoryBookStatusChip.propTypes = {
  deliveredStatus: PropTypes.bool.isRequired,
  isBookAvailable: PropTypes.bool.isRequired,
};

